import React from 'react';
import PropTypes from 'prop-types'; // ES6

import { IconaError } from '../commons/icones';
import PopoverGeneric from '../commons/popoverGeneric';

const PopoverError = (props) => {
    const { contingut, titol, classNameIcona } = props;
    const iconaError = <IconaError className={classNameIcona} />;

    return (
        <PopoverGeneric
            titolPopover={titol}
            contingutPopover={contingut}
            elementBase={iconaError}
        />
    );

};

PopoverError.propTypes = {
    contingut: PropTypes.node,
    titol: PropTypes.node,
    classNameIcona: PropTypes.string
};

export default PopoverError;



// WEBPACK FOOTER //
// ./src/components/commons/popoverError.js